import { render, staticRenderFns } from "./ColorSwatchToolbar.vue?vue&type=template&id=5d182604&scoped=true"
import script from "./ColorSwatchToolbar.vue?vue&type=script&lang=js"
export * from "./ColorSwatchToolbar.vue?vue&type=script&lang=js"
import style0 from "./ColorSwatchToolbar.vue?vue&type=style&index=0&id=5d182604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d182604",
  null
  
)

export default component.exports